import { Pipe, PipeTransform } from '@angular/core';

/**
 * get timezone of given date. Relys on brwoser date.
 *
 * Examples:
 *  new Date(2017, 1, 1) => "Eastern Standard Time"
 *  new Date(2017, 4, 12) => "Eastern Day Time"
 *  new Date(2017, 4, 12) => "GMT -0500" if on a browser that doesn't give back the name of the timezone
 */
@Pipe({
  name: 'wlTimeZoneName',
  pure: true,
  standalone: false 
})
export class WlTimeZoneNamePipe implements PipeTransform {
  /**
   * get timezone of given date
   * @param value
   */
  transform(value: Date): string {
    if (!value) return '';
    let timezoneStr: string = '';

    try {
      let timezoneName: string = value
        .toString()
        .split(/\d+:\d\d:\d\d/)[1]
        .replace(/GMT(?:\+|-)\d+/g, '')
        .replace(/\(|\)/g, '')
        .trim();

      if (timezoneName) return timezoneName;

      let timezoneOffsetMinutesTotal = value.getTimezoneOffset();
      let timezoneOffsetHours = Math.floor(timezoneOffsetMinutesTotal / 60);
      let timezoneOffsetMinutes = timezoneOffsetMinutesTotal % 60;

      timezoneStr = timezoneOffsetMinutesTotal < 0 ? '+' : '-';
      timezoneStr += (timezoneOffsetHours < 10 ? '0' : '') + timezoneOffsetHours;
      timezoneStr += (timezoneOffsetMinutes < 10 ? '0' : '') + timezoneOffsetMinutes;
    } catch (e) {
      console.error(e);
    }

    return timezoneStr;
  }
}
//;
